// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-public-current-entry {
  width: 100%;
  flex-shrink: 0;
}
.dl-dialog-public-current-entry__title {
  font-weight: 500;
  margin-bottom: 4px;
  font-size: var(--g-text-body-2-font-size);
}
.dl-dialog-public-current-entry__entry-line {
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  transition: background ease-in-out 0.2s;
}
.dl-dialog-public-current-entry__entry-line:hover {
  background: var(--g-color-base-simple-hover);
}
.dl-dialog-public-current-entry__entry-name {
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-dialog-public-current-entry__current-entry {
  margin-right: 10px;
  margin-left: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.dl-dialog-public-current-entry__entry-icon {
  flex-shrink: 0;
}
.dl-dialog-public-current-entry__other {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 4px;
}
.dl-dialog-public-current-entry__alert {
  margin-right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/CurrentEntrySection/CurrentEntrySection.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;AACJ;AACI;EACI,gBAAA;EACA,kBAAA;EACA,yCAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,uCAAA;AAAR;AAEQ;EACI,4CAAA;AAAZ;AAII;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFR;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,cAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AALR;AAQI;EACI,kBAAA;AANR","sourcesContent":[".dl-dialog-public-current-entry {\n  width: 100%;\n  flex-shrink: 0;\n}\n.dl-dialog-public-current-entry__title {\n  font-weight: 500;\n  margin-bottom: 4px;\n  font-size: var(--g-text-body-2-font-size);\n}\n.dl-dialog-public-current-entry__entry-line {\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  transition: background ease-in-out 0.2s;\n}\n.dl-dialog-public-current-entry__entry-line:hover {\n  background: var(--g-color-base-simple-hover);\n}\n.dl-dialog-public-current-entry__entry-name {\n  margin-left: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-dialog-public-current-entry__current-entry {\n  margin-right: 10px;\n  margin-left: 4px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.dl-dialog-public-current-entry__entry-icon {\n  flex-shrink: 0;\n}\n.dl-dialog-public-current-entry__other {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-right: 4px;\n}\n.dl-dialog-public-current-entry__alert {\n  margin-right: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
